import { Box, Button, Typography, styled, Chip, Grid, Card, CardContent } from "@mui/material";
import ContentDetail from "./components";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";


const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
`;

const StatusChip = styled(Chip)({
    marginLeft: 5,
    backgroundColor: "#333333 !important",
    fontWeight: 600,
    border: "1px solid #449095"

});

const TiresIAExplain = ({ setMessage, setViewExplain, message, coinvIp, content, maxCardHeight }) => {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    marginBottom: 3,
                }}
            >
                {window.innerWidth > 1024 ? (
                    <>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setMessage("");
                                setViewExplain(false);
                            }}
                            sx={{
                                backgroundColor: "#2d2d2d !important",
                                mt: 3,
                                mb: 2,
                                "&:hover": {
                                    backgroundColor: "#eaeaea !important",
                                    color: "#131C2D",
                                },
                            }}
                        >
                            <KeyboardDoubleArrowUpIcon />

                            <Typography sx={{ fontSize: { xs: "9px", md: "" }, fontWeight: 900 }}>
                                Return to the table
                            </Typography>
                        </Button>
                        <StatusChip label={`${message}`} />
                        <StatusChip label={`${coinvIp}`} />
                    </>
                ) : (
                    <></> // Empty fragment if condition is not met
                )}
            </Box>

            <Grid container spacing={1}>
                {/* Conditional rendering based on window width */}
                {window.innerWidth <= 1024 && (
                    <>
                        <Grid
                                                        xs={12}
                            size={""}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setMessage("");
                                    setViewExplain(false);
                                }}
                                sx={{
                                    fontWeight: "bold",
                                    backgroundColor: "#7f7f7f !important",
                                    mt: 3,
                                    mb: 2,
                                    "&:hover": {
                                        backgroundColor: "whitesmoke !important",
                                        color: "#131C2D !important",
                                    },
                                }}
                            >
                                <KeyboardDoubleArrowUpIcon />

                                <Typography sx={{ fontSize: { xs: "9px", md: "" } }}>
                                    Return to the table
                                </Typography>
                            </Button>{" "}
                        </Grid>
                        <Grid
                                                        xs={12}
                            size={""}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <StatusChip label={`${message}`} fontWeight={300} />
                        </Grid>
                        <Grid
                                                        xs={12}
                            size={""}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <StatusChip label={`${coinvIp}`} fontWeight={300} />
                        </Grid>
                    </>
                )}
                {/* Card 1 - Messaggio Utente */}

                {/* Card 2 - Risposta GPT */}
                <Grid size={12}>
                    <StyledCard
                        sx={{
                            maxHeight: { xs: "20%", md: maxCardHeight },
                            overflow: "auto",
                            wordWrap: "break-word",
                            transition:
                                "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
                            ":hover": {
                                boxShadow: "0px 50px 55px rgba(0,0,0,0.2)",
                                transform: "translateY(-10px)",
                            },
                        }}
                    >
                        <CardContent>
                            <Typography color="textSecondary" variant="h3" gutterBottom>
                                Tires-IA's Event Analysis
                            </Typography>
                            <ContentDetail 
                            message={
                                `${message}${content?.contents?.length ? `. Raw payload content contains ${content.contents.map(item => item.value).join(' ')}` : ''}`
                            } 
                            />
                        </CardContent>
                    </StyledCard>
                </Grid>
            </Grid>

        </>
    )
}

export default TiresIAExplain